// this function will convert string booleans to boolean types
// it will also normalize any overloaded query params the app can receive - eg: eventId/gameId
module.exports = (queryObj = {}) => {
    const convertedQuery = {};
    for (const query in queryObj) {
        if (queryObj.hasOwnProperty(query)) {
            let convertedVal = queryObj[query];

            if (convertedVal === 'true') {
                convertedVal = true;
            } else if (convertedVal === 'false') {
                convertedVal = false;
            }

            // convert gameId to eventId (which is what our APIs understand)
            if (query === 'gameId') {
                convertedQuery['eventId'] = convertedVal;
            } else {
                convertedQuery[query] = convertedVal;
            }
        }
    }
    return convertedQuery;
};



// WEBPACK FOOTER //
// ./app/lib/format/normalizeQueryString.js